import AttachmentApi from "../api/services/AttachmentApi";
import EnqueuedFile from "../components/Gallery/model/EnqueuedFile";
import Attachment from "../api/models/Attachment";

type UploadQueue = {
  enqueuedFile: EnqueuedFile;
  afterUpload?: (attachment: Attachment) => Promise<unknown>;
  showMessage?: (message: string, type: "error" | "info") => void;
};

export default class UploadHelper {
  private queue: UploadQueue[] = [];

  private uploading = false;

  constructor(private attachmentApi: AttachmentApi) {
    this.attachmentApi = attachmentApi;
  }

  public upload(
    files: EnqueuedFile[],
    afterUpload?: (attachment: Attachment) => Promise<unknown>,
    showMessage?: (message: string, type: "error" | "info") => void,
  ): void {
    this.queue.push(
      ...files.map((enqueuedFile) => ({
        enqueuedFile,
        afterUpload,
        showMessage,
      })),
    );
    if (!this.uploading) {
      const file = this.queue.shift();
      if (file) {
        this.uploadFile(file);
      }
    }
  }

  private uploadFile(file: UploadQueue) {
    this.uploading = true;
    const formData = new FormData();
    formData.append("file", file.enqueuedFile.file);
    if (file.enqueuedFile.name) {
      formData.append("filename", file.enqueuedFile.name);
    }
    formData.append("description", file.enqueuedFile.description || "");
    if (file.enqueuedFile.flag) {
      formData.append("tags", file.enqueuedFile.flag.key);
    }
    this.attachmentApi
      .uploadFile(formData)
      .then((response) => {
        if (file.afterUpload) {
          return file.afterUpload(response.data);
        }
      })
      .then(() => {
        const finishedMessage = file.enqueuedFile.notifications?.finished;
        if (file.showMessage && finishedMessage) {
          file.showMessage(finishedMessage, "info");
        }
      })
      .catch(() => {
        const errorMessage = file.enqueuedFile.notifications?.error;
        if (file.showMessage && errorMessage) {
          file.showMessage(errorMessage, "error");
        }
      })
      .finally(() => {
        const nextFile = this.queue.shift();
        if (nextFile) {
          this.uploadFile(nextFile);
        } else {
          this.uploading = false;
        }
      });
  }
}
